import Graph from "./section/Graph";
import Stories from "../Home/Section/Stories";
import Launch from "../Home/Section/Launch";
import { Link } from "react-router-dom";
import ZeussToken from "../../../Contract/zeussToken.json"
const Staking = () => {
  return (
    <>
      <div className="topbar">
        <h4>
          $ZEUSS Contract Address{" "}
          <Link
            target="_blank"
            to={`https://etherscan.io/token/${ZeussToken.address}`}
          >
            {ZeussToken.address}
          </Link>
        </h4>
      </div>
      <div className="wrapper">
        <div className="pageback">
          <section className="Terms Contact">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="heading text-center">
                    <h4>Get In Touch</h4>
                    <p>
                      The distribution of $ZEUSS token rewards will occur on the
                      ETH chain. The reward rate and distribution period are yet
                      to be finalized. Rewards will be claimable once the
                      claiming feature goes live.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <Graph />
          <Stories />
          <Launch />
        </div>
      </div>
    </>
  );
};
export default Staking;
